module.exports = __webpack_public_path__ + "img/3.1cfe2dd0.jpg";